// LIBRERIE/IMPORTS
import React from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface ServicesSectionProps {
  showServices: boolean;
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ showServices }) => {
  const { t } = useTranslation();

  if (!showServices) return null;

  const servicesLinkTitle = t('navigation.servicesLinkTitle');
  const sellLinkTitle = t('navigation.sellLinkTitle');
  const searchLinkTitle = t('navigation.searchLinkTitle');
  const contactButtonText = t('homePage.agencyInfoSnippet.contactButton');

  return (
    <section className="space-ptb bg-green" id="service-box">
      <div className="container">
        <div className="row align-items-center justify-content-center">

          {/* Colonna Sinistra: Link Servizi */}
          <div className="col-12 col-sm-10 col-lg-6">
            <ul className="p-0 mb-5 mb-lg-0">

              {/* Link Servizi */}
              <li className="mb-4 ">
                <Link to="/servizi" title={servicesLinkTitle ?? ''}>
                  {t('homePage.servicesSection.servicesDescription')}
                  <i className="text-primary fa-md d-none d-sm-inline">
                    <FontAwesomeIcon icon={faArrowCircleRight}  size="xl"/>
                  </i>
                </Link>
              </li>

              {/* Link Promozione */}
              <li className="mb-4">
                <Link to="/promozione-immobiliare" title={sellLinkTitle ?? ''}>
                   {t('homePage.servicesSection.promotionDescription')}
                   <i className="text-primary fa-md d-none d-sm-inline">
                    <FontAwesomeIcon icon={faArrowCircleRight} size="xl"/>
                   </i>
                   
                </Link>
              </li>

              {/* Link Partner */}
              <li className="mb-4">
                <Link to="/partners" title={searchLinkTitle ?? ''}>
                  {t('homePage.servicesSection.partnerDescription')}
                  <i className="text-primary fa-md d-none d-sm-inline">
                    <FontAwesomeIcon icon={faArrowCircleRight} size="xl"/>
                  </i>
                </Link>
              </li>

            </ul>
          </div>

          {/* Colonna Destra: Info Agenzia */}
          <div className="col-12 col-sm-10 col-lg-6 text-center col-dx">
            <div className="p-3">

              <h3 className="mb-3">{t('homePage.presentation.presentationTitle')}</h3>
              <p>{t('homePage.agencyInfoSnippet.specialization')}</p>
              <p>{t('homePage.agencyInfoSnippet.support')}</p>
              <p className="mb-4">{t('homePage.agencyInfoSnippet.contact')}</p>

              {/* Bottone Contatti */}
              <Link to="/contatti" title={contactButtonText ?? ''} className="btn btn-inverse text-uppercase">
                {contactButtonText}
              </Link>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;